import { clsx } from 'clsx';
import { type FC, type ReactNode } from 'react';

import styles from './SEOBlockLayout.css';

type SEOBlockLayoutProps = {
  header: ReactNode;
  quickLinks: ReactNode;
  viewModeSwitcher: ReactNode;
  isNarrow: boolean;
};

export const SEOBlockLayout: FC<SEOBlockLayoutProps> = ({ header, quickLinks, viewModeSwitcher, isNarrow }) => {
  return (
    <section className={clsx(styles['container'], { [styles['container-narrow']]: isNarrow })}>
      <div className={styles['header']}>
        {header}
        <div className={styles['view-mode-switcher']}>{viewModeSwitcher}</div>
      </div>
      <div className={styles['quick-links']}>{quickLinks}</div>
    </section>
  );
};
